// 引入vue
import Vue from 'vue'
// 引入elemennt组件
import ElementUI from 'element-ui'
// 引入ant组件
import { Popover, Modal, Button, Checkbox } from 'ant-design-vue'
import Vant from 'vant'
// 引入vuex实例
import store from './store'
// 引入app
import App from './App.vue'
// 引入路由实例
import router from './router/index.js'
// 引入element组件样式
import 'element-ui/lib/theme-chalk/index.css'
// 引入ant组件样式
import 'ant-design-vue/dist/antd.css'
import 'vant/lib/index.css'

Vue.use(Vant)

// 挂载组件
Vue.component('UserNotice', window.hanMeetingComponent.UserNotice)
Vue.use(ElementUI).use(Popover).use(Modal).use(Button).use(Checkbox)

// 关闭生产提示
Vue.config.productionTip = false
new Vue({
  // 使用路由
  router,
  // 使用vuex
  store,
  render: (h) => h(App)
}).$mount('#app')
